const setRatingDistributionValues = values => {
  const isArray = Array.isArray(values)
  const ratings = isArray ? values.map(value => value.reviews || value.count) : Object.values(values)
  let formattedValues = {}
  if (isArray) {
    values.forEach((value, index) => {
      formattedValues[index + 1] = value.reviews || value.count
    })
  } else {
    formattedValues = values
  }
  const maxNum = Math.max(...ratings)

  const percentageValues = {}

  Object.keys(formattedValues).map(key => {
    const val = formattedValues[key]
    if (val === 0) {
      percentageValues[key] = -1
    } else {
      percentageValues[key] = (val * 100) / maxNum
    }
    return percentageValues
  })

  return isArray
    ? Object.values(percentageValues).map((percentage, index) => {
        return {
          reviews: values[index].reviews || values[index].count,
          percentage: Math.ceil(percentage),
          starRating: values[index].starRating || values[index].value,
        }
      })
    : percentageValues
}

export default setRatingDistributionValues
